import { render, staticRenderFns } from "./TrangCapNhatVaiTro.vue?vue&type=template&id=b12ece48&"
import script from "./TrangCapNhatVaiTro.vue?vue&type=script&lang=js&"
export * from "./TrangCapNhatVaiTro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports